import { z } from "zod";
// Filter configuration schema
export const filterConfigItemSchema = z.object({
    type: z.enum(["date-range", "select", "multi-select"]),
    label: z.string(),
    placeholder: z.string().optional(),
    parameterName: z.string(),
});
export const filterConfigSchema = z.array(filterConfigItemSchema);
// Dashboard schema
export const dashboardSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    title: z.string(),
    slug: z.string(),
    description: z.string().nullable(),
    isDefault: z.boolean(),
    filterConfig: filterConfigSchema.nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
// Create dashboard input schema
export const createDashboardInputSchema = z.object({
    title: z.string().min(1, "Title is required"),
    description: z.string().optional(),
    isDefault: z.boolean().optional().default(false),
    filterConfig: filterConfigSchema.optional(),
});
// Update dashboard input schema
export const updateDashboardInputSchema = z.object({
    title: z.string().min(1, "Title is required").optional(),
    description: z.string().optional(),
    isDefault: z.boolean().optional(),
    filterConfig: filterConfigSchema.optional(),
});
// Dashboard list response schema
export const dashboardListResponseSchema = z.object({
    dashboards: z.array(dashboardSchema),
});
// Single dashboard response schema
export const dashboardResponseSchema = dashboardSchema;
// Delete response schema
export const deleteDashboardResponseSchema = z.object({
    deleted: z.boolean(),
    newDefaultDashboard: dashboardSchema.nullable().optional(),
});
